"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _TrendingDownRounded = _interopRequireDefault(require("@material-ui/icons/TrendingDownRounded"));

var _TrendingUpRounded = _interopRequireDefault(require("@material-ui/icons/TrendingUpRounded"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      height: '100%'
    },
    title: {
      padding: '8px'
    }
  };
});

var WidgetStats = function WidgetStats(_ref) {
  var title = _ref.title,
      value = _ref.value,
      prev = _ref.prev,
      units = _ref.units,
      children = _ref.children,
      trendInfo = _ref.trendInfo;
  var classes = useStyles();
  var isTrendPercentage = trendInfo.isTrendPercentage,
      upIsGreen = trendInfo.upIsGreen,
      comparedTo = trendInfo.comparedTo,
      up = trendInfo.up,
      down = trendInfo.down;
  var trendColours = upIsGreen ? ['green', 'red'] : ['red', 'green'];
  var trend = isTrendPercentage ? Math.round((value - prev) / prev * 100).toLocaleString() : Math.round(value - prev).toLocaleString();
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: classes.paper,
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.title,
    variant: "subtitle2",
    gutterBottom: true
  }, title), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    gutterBottom: true
  }, "".concat(value.toLocaleString(), " ").concat(units)), children && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, children), prev && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, trend > 0 ? /*#__PURE__*/_react["default"].createElement(_TrendingUpRounded["default"], {
    style: {
      paddingRight: '8px',
      color: trendColours[0]
    }
  }) : /*#__PURE__*/_react["default"].createElement(_TrendingDownRounded["default"], {
    style: {
      paddingRight: '8px',
      color: trendColours[1]
    }
  }), trend, isTrendPercentage ? '%' : " ".concat(units), trend > 0 ? " ".concat(up, " ") : " ".concat(down, " "), comparedTo));
};

WidgetStats.propTypes = {
  title: _propTypes["default"].string,
  value: _propTypes["default"].number,
  prev: _propTypes["default"].number,
  trendInfo: _propTypes["default"].object,
  children: _propTypes["default"].object,
  units: _propTypes["default"].string
};
WidgetStats.defaultProps = {
  title: 'Untitled',
  value: 0,
  prev: null,
  trendInfo: {
    isTrendPercentage: false,
    upIsGreen: true,
    comparedTo: '',
    up: '',
    down: ''
  },
  children: null,
  units: ''
};
var _default = WidgetStats;
exports["default"] = _default;